import React from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import clsx from 'clsx';
import {
  Box,
  Button, 
	Card, 
	CardHeader,
  CardMedia,
	CardContent,
  CardActions,
  CardActionArea,
	Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Avatar, 
	IconButton,
  Typography,
	Paper,
} from '@material-ui/core';

import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles((theme) => ({
  root: {
    //maxWidth: '50%',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

export default function RecipeReviewCard(props) {
  const theme = useTheme();

  const [viewOpen, setViewOpen] = React.useState(false);
  const viewFullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const peloton = props.peloton;
  // const leader = peloton.leader;
  const pelotonName = peloton.name;
  const description = peloton.description; 
  const category = peloton.category;
  const thumbFilePath = peloton.clubThumbFiles.length > 0 ? findFilePath(peloton.clubThumbFiles, "MEDIUM") : "";
  const city = peloton.city;
  const country = peloton.country;

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleViewOpen = () => {
    setViewOpen(true);
  };
  const handleViewClose = () => {
    setViewOpen(false);
  };

  // 펠로톤 클럽 등록
  const handleViewSubmit = async (e) => {
    e.preventDefault();
  }

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  
  function findFilePath(thumbFiles, size) {
    const targetFile = thumbFiles.find(file => file.thumbnailSize === size);
    const originFile = thumbFiles.find(file => file.thumbnailSize === "ORIGIN");
    return targetFile ? targetFile.filePath : originFile.filePath;
  }

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {category}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={pelotonName}
        // subheader={leader}
      />

      <CardActionArea onClick={handleViewOpen}>
        <CardMedia 
          style={{height:'120px',backgroundImage:`url(${thumbFilePath})`,backgroundSize:'cover',backgroundPosition:'center',backgroundRepeat:'no-repeat' }}
          component="div"
        >
        </CardMedia >
        <CardContent style={{paddingTop:'0px',paddingBottom:'0px'}}>
        </CardContent>
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="div">
            {description}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="div" align='right'>
            {city} {country}
          </Typography>
        </CardContent>
      </CardActionArea>              
      <CardActions style={{display:'none'}} disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>

      <Collapse in={expanded} timeout="auto" unmountOnExit disableStrictModeCompat="true">
        <CardContent>
          <Typography paragraph>Description</Typography>
          <Typography paragraph>
            
          </Typography>
          <Typography paragraph>
            
          </Typography>
          <Typography paragraph>
           
          </Typography>
          <Typography>
            
          </Typography>
        </CardContent>
      </Collapse>


      <Dialog
        id="view-peloton-dialog" 
        fullScreen={viewFullScreen}
        open={viewOpen}
        onClose={handleViewClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{pelotonName}</DialogTitle>
            <form onSubmit={handleViewSubmit}>
              <CardMedia
                className={classes.media}
                image={thumbFilePath}
                title={pelotonName}
              />
              <DialogContent>                
                <DialogContentText>
                 {description}
                </DialogContentText>
                <Typography component="div">
                  {city} {country} 지역의 펠로톤입니다
                </Typography>
                <Typography component="div">
                  카테고리 {category} 이하는 가입이 불가합니다
                </Typography>
              </DialogContent>

              <DialogActions>
                <Button autoFocus onClick={handleViewClose} color="primary">
                  취소하기
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  신청하기
                </Button>
              </DialogActions>
            </form>
      </Dialog>
    </Card>
  );
}
